import { Box, Radio, TextField, Typography, useTheme } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import { keyframes } from "@mui/system";
import WalletAddSVG from "../../../../../media/images/icons/wallet-add";
import PlusCircleSvg from "../../../../../media/images/icons/plus-circle";
import samanLogo from "../../../../../media/images/icons/saman-logo+(1) 1.svg";
import CustomButton from "../../../../components/CustomButton";
import RefreshSVG from "../../../../../media/images/icons/refresh";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
interface Props {
  show: boolean;
}

const scale = keyframes`
  from {
    scale: 0;
  }
  to {
    scale: 1;

  }
`;
export default function ChargeWalletBox({ show = true }: Props) {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: show ? "" : "none",
        backgroundColor: "background.default",
        borderRadius: "16px",
        // scale: show ? 1 : 0,
        // border: "1px solid gray",
        mt: 3,
        // transition: "scale 0.3s",
        animation: `${scale} 0.3s ease`,
        padding: "10px",
      }}
    >
      <Box
        sx={{
          boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.1) inset",
          //   border: "1px solid gray",
          backgroundColor: "info.light",
          borderRadius: "12px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          paddingY: "12px",
        }}
      >
        <WalletAddSVG color={theme.palette.secondary.main} />
        <TextField
          type="number"
          placeholder="مبلغ شارژ حساب را وارد کنید(ریال)"
          size="small"
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
            },

            "& .MuiInputBase-input": {
              border: "none !important",
              padding: "0px",
              outline: "none !important",
              minWidth: "200px",
              textAlign: "center",
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
            },
            border: "none",
          }}
        />
      </Box>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography>دسترسی راحت:</Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "info.light",
              padding: "3px",
              borderRadius: "8px",
            }}
          >
            <PlusCircleSvg color={theme.palette.textColor.main} />
            <Typography> 20,000 تومان</Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "info.light",
              padding: "3px",
              borderRadius: "8px",
            }}
          >
            <PlusCircleSvg color={theme.palette.textColor.main} />
            <Typography> 20,000 تومان</Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography
          noWrap
          sx={{
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          درگاه بانک انتخابی:
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "info.light",
              borderRadius: "8px",
              paddingX: "3px",
              paddingY: "6px",
            }}
          >
            <input type="radio" />
            <img width={50} src={samanLogo} alt="" />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "info.light",
              borderRadius: "8px",
              paddingX: "3px",
              paddingY: "6px",
            }}
          >
            <input type="radio" />
            <img width={50} src={samanLogo} alt="" />
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "info.light",
              borderRadius: "8px",
              paddingX: "3px",
              paddingY: "6px",
            }}
          >
            <input type="radio" />
            <img width={50} src={samanLogo} alt="" />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          mt: 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Typography>معادل: 20,000 تومان</Typography>
        <CustomButton
          title="پرداخت در درگاه بانک سامان"
          bgColor="success.main"
          fSize="14px"
          px="6px"
          py="4px"
          borderRadius="6px"
          color="darkStatic.main"
          icon2={<ArrowLeftSVG color="#fff" />}
        />
      </Box>
    </Box>
  );
}
